// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic styling for printable documents */
.printable-container {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 800px;
  margin: auto;
  background-color: #fff;
  color: #000;
}

.printable-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 15px;
}

.printable-header h1 {
  margin: 0 0 5px 0;
  font-size: 1.8em;
}

.printable-header p {
  margin: 0;
  font-size: 1em;
  color: #333;
}

section {
  margin-bottom: 25px;
}

section h2 {
  font-size: 1.3em;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  color: #111;
}

/* Summary Section */
.summary-section .summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); /* Responsive grid */
  gap: 10px 20px; /* Row and column gap */
  font-size: 0.95em;
  line-height: 1.5;
}

.summary-section .summary-grid div {
  padding: 5px 0;
}

.summary-section .summary-grid strong {
  color: #333;
}

/* Table Styling */
.details-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
}

.details-table th,
.details-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  vertical-align: top;
}

.details-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* Right-align currency columns */
.details-table td:nth-child(2), /* Summa dokhoda */
.details-table td:nth-child(4), /* Summa zakaza */
.details-table td:nth-child(5), /* Oplacheno */
.details-table td:nth-child(6) { /* Ostatok */
  text-align: right;
}


.printable-footer {
  margin-top: 40px;
  padding-top: 15px;
  border-top: 1px solid #ccc;
  text-align: center;
  font-size: 0.8em;
  color: #555;
}

/* Print-specific styles */
@media print {
  body {
    margin: 0;
    padding: 0;
    background-color: #fff;
  }
  .printable-container {
    max-width: 100%;
    box-shadow: none;
    margin: 0;
    padding: 10mm;
    border: none;
  }
  .no-print {
    /* display: none; */
  }
  .details-table th,
  .details-table td {
    border: 1px solid #aaa !important;
  }
  tr, section, .summary-grid div {
    page-break-inside: avoid;
  }
  h1, h2 {
    page-break-after: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableFinancialReport.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D,EAAE,oBAAoB;EACjF,cAAc,EAAE,uBAAuB;EACvC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;;;iCAGiC,YAAY;EAC3C,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,iCAAiC;EACnC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Basic styling for printable documents */\n.printable-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  max-width: 800px;\n  margin: auto;\n  background-color: #fff;\n  color: #000;\n}\n\n.printable-header {\n  text-align: center;\n  margin-bottom: 30px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 15px;\n}\n\n.printable-header h1 {\n  margin: 0 0 5px 0;\n  font-size: 1.8em;\n}\n\n.printable-header p {\n  margin: 0;\n  font-size: 1em;\n  color: #333;\n}\n\nsection {\n  margin-bottom: 25px;\n}\n\nsection h2 {\n  font-size: 1.3em;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n  color: #111;\n}\n\n/* Summary Section */\n.summary-section .summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); /* Responsive grid */\n  gap: 10px 20px; /* Row and column gap */\n  font-size: 0.95em;\n  line-height: 1.5;\n}\n\n.summary-section .summary-grid div {\n  padding: 5px 0;\n}\n\n.summary-section .summary-grid strong {\n  color: #333;\n}\n\n/* Table Styling */\n.details-table table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  font-size: 0.9em;\n}\n\n.details-table th,\n.details-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.details-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n/* Right-align currency columns */\n.details-table td:nth-child(2), /* Summa dokhoda */\n.details-table td:nth-child(4), /* Summa zakaza */\n.details-table td:nth-child(5), /* Oplacheno */\n.details-table td:nth-child(6) { /* Ostatok */\n  text-align: right;\n}\n\n\n.printable-footer {\n  margin-top: 40px;\n  padding-top: 15px;\n  border-top: 1px solid #ccc;\n  text-align: center;\n  font-size: 0.8em;\n  color: #555;\n}\n\n/* Print-specific styles */\n@media print {\n  body {\n    margin: 0;\n    padding: 0;\n    background-color: #fff;\n  }\n  .printable-container {\n    max-width: 100%;\n    box-shadow: none;\n    margin: 0;\n    padding: 10mm;\n    border: none;\n  }\n  .no-print {\n    /* display: none; */\n  }\n  .details-table th,\n  .details-table td {\n    border: 1px solid #aaa !important;\n  }\n  tr, section, .summary-grid div {\n    page-break-inside: avoid;\n  }\n  h1, h2 {\n    page-break-after: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
